import { createReducer, createActions } from "reduxsauce";
import get from "lodash/get";

/**
 * ------------- Types and Action Creators -------------
 * The keys of the object will become keys of the Creators.
 * They will also become the keys of the Types after being
 * converted to SCREAMING_SNAKE_CASE.
 */
const { Types, Creators } = createActions({
  requestEstimateOverview: ["id"],
  requestEstimateOverviewFailure: null,
  requestEstimateOverviewSuccess: ["data"],
  fetchSoilFeatures: ["data"],
  fetchSoilFeaturesSuccess: ["data"],
  createListingFromEstimate: ["id"],
  createListingFromEstimateFailure: null,
  createListingFromEstimateSuccess: ["data"],
  clearEstimateOverviewData: null,
});

export const EstimateOverviewTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  farm: {
    coordinates: null,
    stateCode: null,
    fieldsCount: null,
    location: {
      state: null,
      county: null,
      stateCode: null,
    },
  },
  estimateRequest: {
    stateName: null,
    avgPrice: 0,
    lowPrice: 0,
    highPrice: 0,
    totalAcres: 0,
    tillableAcres: 0,
    soilIndex: null,
    indexType: null,
    crdValue: null,
    crdName: null,
    listingId: null,
    user: {
      id: null,
    },
  },
  soilData: [],
  autoValues: {
    weather: {
      temperature: {
        value: 0,
        percentile: 0,
      },
      precipitation: {
        value: 0,
        percentile: 0,
      },
    },
    soil: {
      corn: {
        value: 0,
        percentile: 0,
      },
      soybean: {
        value: 0,
        percentile: 0,
      },
    },
  },
  stateValues: [0, 0, 0, 0, 0],
  isFeatching: false,
  isFetchingSoilAreas: true,
};

/* ------------- Reducers ------------- */

export const requestEstimateOverview = (state = INITIAL_STATE) => ({
  ...state,
  isFeatching: true,
});

export const requestEstimateOverviewFailure = (state = INITIAL_STATE) => ({
    ...state,
    isFeatching: false,
  });

export const requestEstimateOverviewSuccess = (state = INITIAL_STATE, action) => {
  const { data } = action;
  const { farm, estimateRequest, location, autoValues, stateValues } = data;

  return {
    ...state,
    isFeatching: false,
    farm: {
      ...farm,
      location,
    },
    estimateRequest,
    autoValues,
    stateValues,
  };
};

export const fetchSoilFeatures = (state = INITIAL_STATE) => ({
  ...state,
  isFetchingSoilAreas: true,
});

export const fetchSoilFeaturesSuccess = (state = INITIAL_STATE, action) => {
  const { data } = action;

  const soilFeatures = get(data, "soilFeatures", []);
  const soilCodes = get(data, "detailInfoList", []);
  const soilSummary = get(data, "soilSummary", []);
  const features = data.soilFeatures ? soilFeatures : soilCodes;
  const soilData = features.reduce((memo, entry) => {
    const item = entry.properties ? entry.properties : entry;
    const record = memo[item.mukey];
    return {
      ...memo,
      [item.mukey]: {
        fieldPercentage: item.percent_of_field + (record?.fieldPercentage || 0),
        color: item.color,
        name: item.musym,
      },
    };
  }, {});

  return {
    ...state,
    isFetchingSoilAreas: false,
    farm: {
      ...state.farm,
      soilFeatures,
      soilCodes,
      soilSummary,
    },
    soilData: Object.keys(soilData).map((code) => ({
      soilCode: code,
      color: soilData[code].color,
      soilName: soilData[code].name,
      fieldPercentage: Math.round(soilData[code].fieldPercentage * 100) / 100,
    })),
  };
};

export const createListingFromEstimate = (state = INITIAL_STATE) => ({
  ...state,
  isFeatching: true,
});

export const createListingFromEstimateFailure = (state = INITIAL_STATE) => ({
  ...state,
  isFeatching: false,
});

export const createListingFromEstimateSuccess = (state = INITIAL_STATE) => ({
  ...state,
  isFeatching: false,
});

export const clearEstimateOverviewData = () => INITIAL_STATE;
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.REQUEST_ESTIMATE_OVERVIEW]: requestEstimateOverview,
  [Types.REQUEST_ESTIMATE_OVERVIEW_FAILURE]: requestEstimateOverviewFailure,
  [Types.REQUEST_ESTIMATE_OVERVIEW_SUCCESS]: requestEstimateOverviewSuccess,
  [Types.FETCH_SOIL_FEATURES]: fetchSoilFeatures,
  [Types.FETCH_SOIL_FEATURES_SUCCESS]: fetchSoilFeaturesSuccess,
  [Types.CREATE_LISTING_FROM_ESTIMATE]: createListingFromEstimate,
  [Types.CREATE_LISTING_FROM_ESTIMATE_FAILURE]: createListingFromEstimateFailure,
  [Types.CREATE_LISTING_FROM_ESTIMATE_SUCCESS]: createListingFromEstimateSuccess,
  [Types.CLEAR_ESTIMATE_OVERVIEW_DATA]: clearEstimateOverviewData,
});
